import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import PublicAppBar from "./PublicAppBar";
import ResponsiveAppBar from "./ResponsiveAppBar";
import { useAuth } from "../context/auth";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
  Snackbar,
  Alert,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListSubheader,
  FormControlLabel,
} from "@mui/material";
import { db } from "../api/firebase";
import {
  doc,
  getDoc,
  updateDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import { Checkbox } from "@mui/material";

const steps = ["名前の入力", "居住地の選択", "連絡先の入力"];

const regions = {
  "北海道・東北": [
    "北海道",
    "青森県",
    "岩手県",
    "宮城県",
    "秋田県",
    "山形県",
    "福島県",
  ],
  関東: [
    "茨城県",
    "栃木県",
    "群馬県",
    "埼玉県",
    "千葉県",
    "東京都",
    "神奈川県",
  ],
  中部: [
    "新潟県",
    "富山県",
    "石川県",
    "福井県",
    "山梨県",
    "長野県",
    "岐阜県",
    "静岡県",
    "愛知県",
  ],
  近畿: [
    "三重県",
    "滋賀県",
    "京都府",
    "大阪府",
    "兵庫県",
    "奈良県",
    "和歌山県",
  ],
  中国: ["鳥取県", "島根県", "岡山県", "広島県", "山口県"],
  四国: ["徳島県", "香川県", "愛媛県", "高知県"],
  "九州・沖縄": [
    "福岡県",
    "佐賀県",
    "長崎県",
    "熊本県",
    "大分県",
    "宮崎県",
    "鹿児島県",
    "沖縄県",
  ],
  海外: ["海外（アメリカ）", "海外（その他）"],
};

const municipalities = [
  "札幌市",
  "江別市",
  "千歳市",
  "恵庭市",
  "北広島市",
  "石狩市",
  "当別町",
  "新篠津村",
  "岩見沢市",
  "夕張市",
  "美唄市",
  "芦別市",
  "赤平市",
  "三笠市",
  "滝川市",
  "砂川市",
  "歌志内市",
  "深川市",
  "南幌町",
  "奈井江町",
  "上砂川町",
  "由仁町",
  "長沼町",
  "栗山町",
  "月形町",
  "浦臼町",
  "新十津川町",
  "妹背牛町",
  "秩父別町",
  "雨竜町",
  "北竜町",
  "沼田町",
  "小樽市",
  "倶知安町",
  "寿都町",
  "黒松内町",
  "蘭越町",
  "ニセコ町",
  "喜茂別町",
  "京極町",
  "共和町",
  "岩内町",
  "積丹町",
  "古平町",
  "仁木町",
  "余市町",
  "島牧村",
  "真狩村",
  "留寿都村",
  "泊村",
  "神恵内村",
  "赤井川村",
  "室蘭市",
  "苫小牧市",
  "登別市",
  "伊達市",
  "豊浦町",
  "洞爺湖町",
  "壮瞥町",
  "白老町",
  "厚真町",
  "安平町",
  "むかわ町",
  "浦河町",
  "日高町",
  "平取町",
  "新冠町",
  "様似町",
  "えりも町",
  "新ひだか町",
  "函館市",
  "北斗市",
  "松前町",
  "福島町",
  "知内町",
  "木古内町",
  "七飯町",
  "鹿部町",
  "森町",
  "八雲町",
  "長万部町",
  "江差町",
  "上ノ国町",
  "厚沢部町",
  "乙部町",
  "奥尻町",
  "今金町",
  "せたな町",
  "旭川市",
  "富良野市",
  "士別市",
  "名寄市",
  "鷹栖町",
  "東神楽町",
  "当麻町",
  "比布町",
  "愛別町",
  "上川町",
  "東川町",
  "美瑛町",
  "上富良野町",
  "中富良野町",
  "南富良野町",
  "幌加内町",
  "和寒町",
  "剣淵町",
  "下川町",
  "美深町",
  "中川町",
  "占冠村",
  "音威子府村",
  "留萌市",
  "増毛町",
  "小平町",
  "苫前町",
  "羽幌町",
  "遠別町",
  "天塩町",
  "初山別村",
  "稚内市",
  "浜頓別町",
  "中頓別町",
  "枝幸町",
  "豊富町",
  "幌延町",
  "礼文町",
  "利尻町",
  "利尻富士町",
  "猿払村",
  "網走市",
  "北見市",
  "紋別市",
  "美幌町",
  "津別町",
  "大空町",
  "斜里町",
  "清里町",
  "小清水町",
  "訓子府町",
  "置戸町",
  "佐呂間町",
  "遠軽町",
  "湧別町",
  "滝上町",
  "興部町",
  "雄武町",
  "西興部村",
  "帯広市",
  "音更町",
  "士幌町",
  "上士幌町",
  "鹿追町",
  "新得町",
  "清水町",
  "芽室町",
  "大樹町",
  "広尾町",
  "幕別町",
  "池田町",
  "豊頃町",
  "本別町",
  "足寄町",
  "陸別町",
  "浦幌町",
  "中札内村",
  "更別村",
  "釧路市",
  "釧路町",
  "厚岸町",
  "浜中町",
  "標茶町",
  "弟子屈町",
  "白糠町",
  "鶴居村",
  "根室市",
  "別海町",
  "中標津町",
  "標津町",
  "羅臼町",
];

const PublicRouteLayout = () => {
  const { user, loading } = useAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  const [formData, setFormData] = useState({
    name: "",
    furigana: "",
    email: "",
    phone: "",
    prefecture: "",
    municipality: "",
    prefectureConfirmed: false, // ← 追加
  });
  const [fetchFailed, setFetchFailed] = useState(false);

  useEffect(() => {
    const createUserIfNotExists = async () => {
      if (user) {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);

        console.log(
          "🧪 createUserIfNotExists() 実行 - doc exists?",
          userSnap.exists()
        );

        if (!userSnap.exists()) {
          const newUser = {
            uid: user.uid,
            name: user.displayName || "",
            email: user.email || "",
            avatar: user.photoURL || "",
            createdAt: serverTimestamp(),
            isOnline: true,
            isLogin: true,
            isStop: false,
          };

          await setDoc(userRef, newUser);
          console.log("✅ setDoc 実行完了。Firestoreへの反映を確認中...");

          // 🔁 Firestore に反映されるのを最大3回リトライ
          for (let i = 0; i < 3; i++) {
            await new Promise((res) => setTimeout(res, 300 * (i + 1))); // 300ms, 600ms, 900ms
            const confirmSnap = await getDoc(userRef);
            if (confirmSnap.exists()) {
              console.log("📥 Firestore 反映確認 OK");
              setUserInfo(confirmSnap.data());
              return;
            } else {
              console.warn("⏳ Firestore反映待ち...リトライ", i + 1);
            }
          }

          console.error(
            "❌ setDoc後、3回リトライしても Firestore に存在しませんでした"
          );
        }
      }
    };

    createUserIfNotExists();
  }, [user]);

  useEffect(() => {
    const fetchUser = async () => {
      console.log("🔥 fetchUser 発動", user);

      if (!user?.uid) return;
      const userRef = doc(db, "users", user.uid);

      let docSnap = await getDoc(userRef);
      for (let i = 0; i < 3; i++) {
        if (docSnap.exists()) break;
        console.warn("⏳ Firestore user 再取得中...リトライ", i + 1);
        await new Promise((res) => setTimeout(res, 300 * (i + 1))); // 300, 600, 900ms
        docSnap = await getDoc(userRef);
      }

      if (docSnap.exists()) {
        const data = docSnap.data();
        // console.log("📥 fetchUser 成功", data);
        setUserInfo(data);

        const isMissing =
          !("registrationName" in data) || !data.registrationName?.trim();
        if (isMissing) {
          // console.log("🟨 registrationName 未登録 → ステッパーダイアログ表示");
          setShowDialog(true);
        }
      } else {
        console.error("❌ ユーザデータの取得に失敗しました");
        setFetchFailed(true); // ← ここでエラーハンドリング
      }
    };

    if (!loading && user?.uid) {
      console.log("🔍 loading完了 && userあり → fetchUser呼び出し");
      fetchUser();
    }
  }, [user?.uid, loading]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!user) return;
    const userRef = doc(db, "users", user.uid);
    await updateDoc(userRef, {
      registrationName: formData.name,
      registrationFurigana: formData.furigana,
      registrationEmail: formData.email,
      registrationPhone: formData.phone,
      prefecture: formData.prefecture,
      municipality:
        formData.prefecture === "北海道" ? formData.municipality : null,
      isVerified: false,
      hasSeenWelcome: true,
      hasSeenThankYou:true,
    });
    setShowDialog(false);
    setSnackOpen(true);
  };

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      handleSubmit();
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            <TextField
              name="name"
              label="名前"
              fullWidth
              margin="dense"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
            <TextField
              name="furigana"
              label="ふりがな"
              fullWidth
              margin="dense"
              value={formData.furigana}
              onChange={handleInputChange}
              required
            />
          </>
        );
      case 1:
        return (
          <>
            <FormControl fullWidth margin="dense">
              <InputLabel>都道府県</InputLabel>
              <Select
                name="prefecture"
                value={formData.prefecture}
                onChange={handleInputChange}
                label="都道府県"
              >
                {Object.entries(regions).flatMap(([region, prefs]) => [
                  <ListSubheader key={region}>{region}</ListSubheader>,
                  ...prefs.map((pref) => (
                    <MenuItem key={pref} value={pref}>
                      {pref}
                    </MenuItem>
                  )),
                ])}
              </Select>
            </FormControl>
            {formData.prefecture === "北海道" && (
              <FormControl fullWidth margin="dense">
                <InputLabel>市区町村</InputLabel>
                <Select
                  name="municipality"
                  value={formData.municipality}
                  onChange={handleInputChange}
                >
                  {municipalities.map((m) => (
                    <MenuItem key={m} value={m}>
                      {m}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.prefectureConfirmed}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      prefectureConfirmed: e.target.checked,
                    }))
                  }
                />
              }
              label="一度決定した居住地の変更は事務局経由で行うこととなります。"
            />
          </>
        );
      case 2:
        return (
          <>
            {/* <TextField
              name="email"
              label="登録時のメールアドレス"
              fullWidth
              margin="dense"
              value={formData.email}
              onChange={handleInputChange}
            /> */}
            <TextField
              name="phone"
              label="登録時の電話番号"
              fullWidth
              margin="dense"
              value={formData.phone}
              onChange={handleInputChange}
            />
          </>
        );
      default:
        return null;
    }
  };

  const isFinalStep = activeStep === steps.length - 1;
  const isNextDisabled =
    (activeStep === 0 && (!formData.name || !formData.furigana)) ||
    (activeStep === 1 &&
      (!formData.prefecture ||
        (formData.prefecture === "北海道" && !formData.municipality) ||
        !formData.prefectureConfirmed)) || // ← チェック追加
    (activeStep === 2 && !formData.email && !formData.phone);

  return (
    <>
      {user ? <ResponsiveAppBar /> : <PublicAppBar />}
      <Box sx={{ p: 2 }}>
        <Outlet />
      </Box>

      <Dialog open={showDialog} fullWidth maxWidth="sm">
        <DialogTitle>初回登録ステップ</DialogTitle>
        <DialogContent>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box sx={{ mt: 2 }}>{renderStepContent()}</Box>
        </DialogContent>
        <DialogActions>
          {activeStep > 0 && <Button onClick={handleBack}>戻る</Button>}
          <Button
            onClick={handleNext}
            disabled={isNextDisabled}
            variant="contained"
          >
            {isFinalStep ? "確認" : "次へ"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={fetchFailed}
        disableEscapeKeyDown
        disableBackdropClick
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>データ取得に失敗しました</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ユーザ登録情報の取得に失敗しました。
            通信状況が不安定な可能性があります。
            <br />
            再読み込みすることで問題が解消することがあります。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => window.location.reload()}
            variant="contained"
            color="primary"
            fullWidth
          >
            再読み込み
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackOpen}
        autoHideDuration={3000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          ご登録ありがとうございます！
        </Alert>
      </Snackbar>
    </>
  );
};

export default PublicRouteLayout;
